/**
 * This is a temporary solution of moving dynamic import out of
 * CoffeeScript code. It unblocks the possibility of using
 * bulk decaffeination tool.
 * After decaf process will be completed, imports should go back inline.
 */
import { importWithRetry } from '@trello/use-lazy-component';

export const boardViewLoader = () =>
  importWithRetry(() =>
    import(
      /* webpackChunkName: "board-view" */ 'app/scripts/views/board/board-view'
    ),
  );

export const cardDetailViewLoader = () =>
  importWithRetry(() =>
    import(
      /* webpackChunkName: "card-detail-view" */ 'app/scripts/views/card/card-detail-view'
    ),
  );
